// helper for downloading files
export const downloadBlob = async (signedUrl, filename) => {
  const fileResponse = await fetch(signedUrl);
  if (!fileResponse.ok) throw new Error("Failed to fetch the file");

  const fileBlob = await fileResponse.blob();
  const fileUrl = URL.createObjectURL(fileBlob);

  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = filename;
  link.click();
};
